import { useForm } from 'react-hook-form';


export default function ResetScore() {


    const { register, handleSubmit, formState: { errors } } = useForm();
    
    const onSubmit = (data) => {

        alert(data.reset)

        if (data.reset == "reset") {
            
        }

    }
    return (
        <div className='container h-100 overflow-auto'>
            <p>
            If you are absolutely sure you want to reset every user's yearly score, please type 'reset' in the input below and then hit submit.
            </p>

            <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="mb-3">
                            <input type="text" className="form-control" id="reset"
                                autoComplete='off' {...register('reset', { required: true , pattern: /reset/})} />
                            {errors.reset?.type === 'required' && <div className='text-danger form-text'>Reset is required</div>}
                            {errors.reset?.type === 'pattern' && <div className='text-danger form-text'>Input value must be 'reset'</div>}
                        </div>
                        

                        <button className='btn btn-success text-white w-30' type='submit'>Submit</button>

                    </form>
        </div>
    )
}